import React, { useEffect } from "react";

// IMPORT USER-DEFINED COMPONENTS HERE //
import CertificationCard from "components/certificationCard/CertificationCard";

// IMPORT OTHERS HERE //
import { certificationsList } from "config/certifications";
import { scrollToTop, generateId, parseIssueDate } from "utils/functions";
import appStyles from "./Certifications.module.scss";

const Certifications = () => {
  useEffect(() => {
    setTimeout(() => {
      scrollToTop({ isSmooth: false });
    }, 0);
  }, []);

  const visibleCertifications = (certificationsList || [])
    .filter((c) => c.show)
    .sort((c1, c2) => parseIssueDate(c2.issueDate) - parseIssueDate(c1.issueDate)); // latest first

  return (
    <main className={appStyles["main-cnt"]} id="certifications">
      <section className={appStyles.header}>
        <p className={appStyles.subtitle}>
          A curated selection of courses and programs I&apos;ve completed to deepen my skills.
        </p>
      </section>

      <section className={appStyles.grid}>
        {visibleCertifications?.map((cert) => (
          <CertificationCard key={generateId(cert.title)} {...cert} />
        ))}
      </section>
    </main>
  );
};

export default Certifications;
